/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.account.configuration.controllers', [
  'acme.common.factory.notice',
  'acme.common.directive.upload',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.factory.gridState',
  'acme.common.service.userPreferences'
])

.controller('AccountConfigurationController', ['$scope', '$filter', '$timeout', 'NoticeFactory', 'ApiService', 'HelpersService', 'CalendarService', 'GridStateFactory', 'UserPreferencesService', function($scope, $filter, $timeout, NoticeFactory, ApiService, HelpersService, CalendarService, GridStateFactory, UserPreferencesService) {

    $scope.accountConfiguration = {

      GLCodes: [],

      filtered: [],

      notice: {},

      searchQuery: '',

      isLoaded: false,

      hasErrorFile: false,

      isSubmitted: false,

      mostRecent: {},
      
      dateFormat: UserPreferencesService.getDateFormat('shortDate', 'dateFormat') +  ' at ' + UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

      gridState: new GridStateFactory(),

      gridOptions: {
        enableRowSelection: false,
        paginate: true,
        pageSize: 50,
        showFooter: true,
        useExternalPagination: true,
        useExternalSorting: true,

        columnDefs: [
          {
            field: 'id',
            displayName: 'ID',
            visible: false
          },
          {
            field: 'fileName',
            displayName: 'name'
          },
          {
            field: 'updatedOn',
            displayName: 'Uploaded on'
          },
          {
            field: 'download',
            displayName: 'Download',
            onCellNavClick: function(row, col) {
              $scope.accountConfiguration.downloadFile(row.entity.fileName);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a class="clickable" data-ng-click="grid.appScope.remove(row.entity.fileName)" role="button">Download<span class="sr-only"> the file</span></a></div>'
          }
        ]
      },

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'GL Code Configuration'
        });

        this.notice = new NoticeFactory();

        this.gridState.updateGridState(null, this.gridOptions.pageSize, 'name', 'asc');

        this.getGLCodes();

        $scope.$on('upload::progress', this.onUploadProgress());
        $scope.$on('upload::add', this.onUploadProgress());
        $scope.$on('upload::remove', this.onUploadRemove);
        $scope.$on('upload::done', this.onUploadDone);
        $scope.$on('upload::error', this.onUploadError);
        $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
      },

      getGLCodes: function() {
        ApiService.glcodes.list(this.gridState.getGridState()).then(this.success.getGLCodes, this.error.getGLCodes);

      },

      search: function() {
        console.log('Model: '+JSON.stringify(this.GLCodes));
        this.filtered = $filter('filter')(this.GLCodes, function(fileItem) {
          var name = fileItem.fileName || '',
            value = (name).toLowerCase();
          console.log('AccountConfiguration::search', fileItem.name, $scope.accountConfiguration.searchQuery, (value.indexOf($scope.accountConfiguration.searchQuery.toLowerCase()) !== -1));
          return (value.indexOf($scope.accountConfiguration.searchQuery.toLowerCase()) !== -1) ? fileItem : null;
        });
      },

      process: function(list) {
        var i, ii, item, aDate, bDate;
        list = list.sort(function(a, b) {
          aDate = CalendarService.parseDate(a.updatedOn).getTime();
          bDate = CalendarService.parseDate(b.updatedOn).getTime();
          if (aDate > bDate) {
            return -1;
          } else if (aDate < bDate) {
            return 1;
          }
          return 0;
        });
        for (i = 0, ii = list.length; i < ii; i++) {
          item = list[i];
          if(item.createdOn) {
            item.createdOn = this.getFilteredDate(item.createdOn);
          }
          if(item.updatedOn) {
            item.updatedOn = this.getFilteredDate(item.updatedOn);
          }
        }
        return list;
      },

      getFilteredDate: function(date) {
        console.log("getFilteredDate", date);
        var d = new Date(date);
        return $filter('date')(new Date(date), this.dateFormat).toLowerCase();
      },

      downloadFile: function(fileName) {
        var form, self = $scope.accountConfiguration;

        form = $('<form></form>').attr('method','get').attr('enctype', 'application/x-www-form-urlencoded').attr('action','/v1/api/glcode/files/'+encodeURIComponent(fileName));
        form.appendTo('body').submit().remove();
      },

      downloadErrorFile: function(fileName) {
        var form, self = $scope.accountConfiguration;

        form = $('<form></form>').attr('method','get').attr('enctype', 'application/x-www-form-urlencoded').attr('action','/v1/api/glcode/files/error'+encodeURIComponent(fileName));
        form.appendTo('body').submit().remove();
      },

      onUploadRemove: function(e, data) {
        var i, ii, self = $scope.accountConfiguration;

        for (i=0,ii=self.GLCodes.length;i<ii;i++) {
          if (data.file.id === self.GLCodes[i].id) {
            self.GLCodes.splice(i, 1);
          }
        }
        self.search();
        console.log('onUploadRemove', self.GLCodes);

      },

      onUploadProgress: function() {
        console.log('Upload::progress');
        $scope.accountConfiguration.isSubmitted = true;
      },

      onUploadDone: function(e, data) {
        var self = $scope.accountConfiguration;
        self.notice.hideErrorMessages();
        self.notice.hideSuccessMessages();

        $timeout.cancel($scope.noticeTimer);
        $scope.accountConfiguration.notice.showSuccessMessages([{
          message: 'Successfully Uploaded!'
        }]);

        $scope.noticeTimer = $timeout(function() {
          $scope.accountConfiguration.notice.hideSuccessMessages();
        }, 3000);

        self.hasErrorFile = false;

        console.log('onUploadDone', data);
        self.getGLCodes();
      },

      onUploadError: function(e, data) {
        var self = $scope.accountConfiguration;
        self.hasErrorFile = false;
        self.isSubmitted = false;
        console.log('onUploadError', data);
        self.notice.showErrorMessages([
          { message: data.result.error }
        ]);
        if (data.result.code === 409) {
          // There was an error parsing the file, so show the link to get the file with errors listed in it.
          self.hasErrorFile = true;
        }
      },

      success: {
        init: function(response) {},
        getGLCodes: function(response) {
          var self = $scope.accountConfiguration;
          self.isSubmitted = false;
          self.GLCodes = self.process(response.data.payload.list);
          //next tick
          $timeout(function() {
            self.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);
            self.search();

            if(self.GLCodes && self.GLCodes.length) {
              self.mostRecent = self.GLCodes[0];
            }

            self.isLoaded = true;
          }, 0);
        }
      },

      error: {
        init: function(response) {},
        getGLCodes: function(response) {
          $scope.accountConfiguration.isSubmitted = false;
        }
      },

      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.accountConfiguration;
        self.gridState.updateGridState(newPage, pageSize);
        self.getGLCodes();
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.accountConfiguration, data = columns[0];
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getGLCodes();
        }
      },
      
      onDateFormatLoad: function (e, data) {
        $scope.accountConfiguration.dateFormat = UserPreferencesService.getDateFormat('shortDate', 'dateFormat') +  ' at ' + UserPreferencesService.getDateFormat('standardTime', 'hourFormat');
      }

    };

    $scope.accountConfiguration.init();

}]);